import { ICellEditorComp, ICellEditorParams } from 'ag-grid-community'
import { httpGet } from 'common/services'

interface ExternalCategory {
  id: number
  path: string
  name: string
  children: ExternalCategory[]
}

interface ProductCategorySelectorParams extends ICellEditorParams {
  path?: string
  values?: ExternalCategory[]
}

function getItemValue(item: ExternalCategory) {
  if (item.path) {
    return item.id + ';' + item.path?.split('/').reverse().join(';')
  } else {
    return item.id + ';' + item.name
  }
}

export class ProductCategorySelector implements ICellEditorComp {
  container: HTMLElement = document.createElement('div')
  filter: string = ''
  filterElement: HTMLInputElement | undefined
  items: ExternalCategory[] | undefined
  params: ICellEditorParams = {} as ProductCategorySelectorParams
  value: string = ''

  init(params: ProductCategorySelectorParams) {
    this.container.setAttribute('style', 'width: 650px; height: 550px; background-color: #ffffff; overflow: scroll')
    this.container.innerHTML = `<div class="form-group m-sm"><input class="full-width" id="filter" type="text" placeholder="Filtrar" /></div><div id="items"></div>`
    this.filter = ''
    this.filterElement = this.container.querySelector('#filter') as HTMLInputElement
    this.params = params

    this.filterElement?.addEventListener('keyup', () => {
      this._updateItems()
    })

    if (params.values && params.values.length > 0) {
      this.items = params.values
    } else if (params.path) {
      httpGet<ExternalCategory[]>(params.path).then((colors) => {
        this.items = colors.value

        this._updateItems()
      })
    }
  }

  afterGuiAttached() {
    this.filterElement?.focus()
  }

  destroy() {
    this._removeApplyListener()
  }

  getGui() {
    return this.container as HTMLElement
  }

  getValue() {
    return this.value
  }

  isPopup() {
    return true
  }

  _applyValue = (event: Event) => {
    this.value = ((event.target as HTMLDivElement).parentNode as HTMLLIElement).dataset.value || ''

    this.params.stopEditing()
  }

  _filterItem(item: ExternalCategory) {
    let result = false

    if (item.path) {
      result = item.path.toUpperCase().includes(this.filter.toUpperCase())
    } else {
      result = item.name.toUpperCase().includes(this.filter.toUpperCase())
    }

    if (item && item.children && item.children.length > 0) {
      item.children.forEach((child: ExternalCategory) => {
        result = result || this._filterItem(child)
      })
    }

    return result
  }

  _renderItem(item: ExternalCategory) {
    let result = ''

    if (item.name !== '') {
      result = `<li class="dd-item" data-value="${getItemValue(item)}")"><div class="dd-handle">${item.name}</div></li>`
    }

    if (item && item.children && item.children.length > 0) {
      result =
        result +
        `<ol class="dd-list">          
          ${item.children
            .filter((it: ExternalCategory) => this._filterItem(it))
            .map((child: ExternalCategory) => {
              return this._renderItem(child)
            })
            .join('')}
        </ol>`
    }

    return result
  }

  _updateItems() {
    this.filter = this.filterElement?.value || ''

    const itemsElement = this.container.querySelector('#items') as HTMLDivElement

    itemsElement.innerHTML = `
          <div class="dd m-sm">
            <ol class="dd-list">
              ${
                this.items &&
                this.items.filter &&
                this.items
                  .filter((it: ExternalCategory) => this._filterItem(it))
                  .map((it: ExternalCategory) => {
                    return this._renderItem(it)
                  })
                  .join('')
              }
            </ol>
          </div>`

    this._registerApplyListener()
  }

  _registerApplyListener() {
    const items = this.container.querySelectorAll('.dd-item')

    items?.forEach((element) => {
      element.addEventListener('click', this._applyValue)
    })
  }

  _removeApplyListener() {
    const items = this.container.querySelectorAll('.dd-item')

    items?.forEach((element) => {
      element.removeEventListener('click', this._applyValue)
    })
  }
}
